export class Veglenkesekvensposisjon {
    constructor(
        readonly id: number,
        readonly relativPosisjon: number,
        readonly kortform: string
    ) {}
}
